import React from "react"
import { Link } from "gatsby"

export default () => (
  <div>
    <Link to={`es/blog`}>es</Link>
    <Link to={`blog`}>en</Link>
  </div>
)
